// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_terceros_promotores.proto (package sextante.plataforma.terceros.promotores.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_terceros_promotores.proto.
 */
export const file_plataforma_terceros_promotores: GenFile = /*@__PURE__*/
  fileDesc("CiRwbGF0YWZvcm1hX3RlcmNlcm9zX3Byb21vdG9yZXMucHJvdG8SKnNleHRhbnRlLnBsYXRhZm9ybWEudGVyY2Vyb3MucHJvbW90b3Jlcy52MSIXChVMaXN0UHJvbW90b3Jlc1JlcXVlc3QiawoWTGlzdFByb21vdG9yZXNSZXNwb25zZRJRCgVpdGVtcxgBIAMoCzJCLnNleHRhbnRlLnBsYXRhZm9ybWEudGVyY2Vyb3MucHJvbW90b3Jlcy52MS5Qcm9tb3RvclBsYXRhZm9ybWFJdGVtItoBChZQcm9tb3RvclBsYXRhZm9ybWFJdGVtEgoKAmlkGAEgASgJEg4KBm5vbWJyZRgCIAEoCRINCgVlbWFpbBgDIAEoCRIQCgh0ZWxlZm9ubxgEIAEoCRIMCgR0aXBvGAUgASgJEhEKCWlzX2FjdGl2bxgGIAEoCBIiChV1c3VhcmlvX3BsYXRhZm9ybWFfaWQYByABKAlIAIgBARIkChxlbmxhemFkb19hX3VzdWFyaW9fZXhpc3RlbnRlGAggASgIQhgKFl91c3VhcmlvX3BsYXRhZm9ybWFfaWQiowEKFkd1YXJkYXJQcm9tb3RvclJlcXVlc3QSDwoCaWQYASABKAlIAIgBARIOCgZub21icmUYAiABKAkSDQoFZW1haWwYAyABKAkSEAoIdGVsZWZvbm8YBCABKAkSEQoEdGlwbxgFIAEoCUgBiAEBEhYKCWlzX2FjdGl2bxgGIAEoCEgCiAEBQgUKA19pZEIHCgVfdGlwb0IMCgpfaXNfYWN0aXZvIigKEVByb21vdG9ySWRSZXF1ZXN0EhMKC3Byb21vdG9yX2lkGAEgASgJIksKFlByb21vdG9yUGVyaW9kb1JlcXVlc3QSEwoLcHJvbW90b3JfaWQYASABKAkSDQoFZGVzZGUYAiABKAMSDQoFaGFzdGEYAyABKAMi5wMKFVByb21vdG9yU3RhdHNSZXNwb25zZRIYChBjbGllbnRlc19hY3Rpdm9zGAEgASgFEhcKD2NsaWVudGVzX251ZXZvcxgCIAEoBRIVCg1vcG9ydHVuaWRhZGVzGAMgASgFEg8KB2NpZXJyZXMYBCABKAUSFwoPdGFzYV9jb252ZXJzaW9uGAUgASgBEhYKDnZlbnRhc190b3RhbGVzGAYgASgDEhcKD3RpY2tldF9wcm9tZWRpbxgHIAEoAxJYCg9ncmFmaWNhX21lbnN1YWwYCCADKAsyPy5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JHcmFmaWNhSXRlbRIcChRncmFudWxhcmlkYWRfZ3JhZmljYRgJIAEoCRJPCgl2c19lcXVpcG8YCiABKAsyPC5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JWc0VxdWlwbxJgChZkaXN0cmlidWNpb25fc2VydmljaW9zGAsgAygLMkAuc2V4dGFudGUucGxhdGFmb3JtYS50ZXJjZXJvcy5wcm9tb3RvcmVzLnYxLlByb21vdG9yU2VydmljaW9JdGVtIloKE1Byb21vdG9yR3JhZmljYUl0ZW0SCwoDbWVzGAEgASgJEhUKDW9wb3J0dW5pZGFkZXMYAiABKAUSDwoHY2llcnJlcxgDIAEoBRIOCgZ2ZW50YXMYBCABKAMidAoQUHJvbW90b3JWc0VxdWlwbxIXCg90YXNhX2NvbnZlcnNpb24YASABKAESFQoNb3BvcnR1bmlkYWRlcxgCIAEoARIXCg90aWNrZXRfcHJvbWVkaW8YAyABKAMSFwoPY2xpZW50ZXNfbnVldm9zGAQgASgBIjoKFFByb21vdG9yU2VydmljaW9JdGVtEhAKCHNlcnZpY2lvGAEgASgJEhAKCGNhbnRpZGFkGAIgASgFImkKF1Byb21vdG9yQ2FydGVyYVJlc3BvbnNlEk4KBWl0ZW1zGAEgAygLMj8uc2V4dGFudGUucGxhdGFmb3JtYS50ZXJjZXJvcy5wcm9tb3RvcmVzLnYxLlByb21vdG9yQ2FydGVyYUl0ZW0ioQIKE1Byb21vdG9yQ2FydGVyYUl0ZW0SCgoCaWQYASABKAkSDgoGbm9tYnJlGAIgASgJEhMKC2NhbnRfZmluY2FzGAMgASgFEhkKEWhlY3RhcmVhc190b3RhbGVzGAQgASgBEikKHGZlY2hhX3ZlbmNpbWllbnRvX3BsYXRhZm9ybWEYBSABKANIAIgBARITCgtwbGFuX2FjdGl2bxgGIAEoCBIZChFzZXJ2aWNpb3NfYWN0aXZvcxgHIAMoCRIlChh1bHRpbWFfb3BvcnR1bmlkYWRfZmVjaGEYCCABKANIAYgBAUIfCh1fZmVjaGFfdmVuY2ltaWVudG9fcGxhdGFmb3JtYUIbChlfdWx0aW1hX29wb3J0dW5pZGFkX2ZlY2hhIm0KGVByb21vdG9ySGlzdG9yaWFsUmVzcG9uc2USUAoFaXRlbXMYASADKAsyQS5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JIaXN0b3JpYWxJdGVtIuABChVQcm9tb3Rvckhpc3RvcmlhbEl0ZW0SEgoKY2xpZW50ZV9pZBgBIAEoCRIWCg5jbGllbnRlX25vbWJyZRgCIAEoCRINCgVzdGFnZRgDIAEoCRIOCgZzb3VyY2UYBCABKAkSWgoJcHJvZHVjdG9zGAUgASgLMkIuc2V4dGFudGUucGxhdGFmb3JtYS50ZXJjZXJvcy5wcm9tb3RvcmVzLnYxLlByb2R1Y3Rvc0hpc3RvcmlhbEl0ZW1IAIgBARISCgpjcmVhdGVkX2F0GAYgASgDQgwKCl9wcm9kdWN0b3MibwoWUHJvZHVjdG9zSGlzdG9yaWFsSXRlbRIOCgZkYXRhYWcYASABKAgSDgoGcmFzdHJvGAIgASgFEg8KB2Jhc2N1bGEYAyABKAUSDQoFdmlzdGEYBCABKAgSFQoNcHJvdGVjX2FjdGl2bxgFIAEoCDKWBgobUHJvbW90b3Jlc1BsYXRhZm9ybWFTZXJ2aWNlEpcBCg5MaXN0UHJvbW90b3JlcxJBLnNleHRhbnRlLnBsYXRhZm9ybWEudGVyY2Vyb3MucHJvbW90b3Jlcy52MS5MaXN0UHJvbW90b3Jlc1JlcXVlc3QaQi5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuTGlzdFByb21vdG9yZXNSZXNwb25zZRKZAQoPR3VhcmRhclByb21vdG9yEkIuc2V4dGFudGUucGxhdGFmb3JtYS50ZXJjZXJvcy5wcm9tb3RvcmVzLnYxLkd1YXJkYXJQcm9tb3RvclJlcXVlc3QaQi5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JQbGF0YWZvcm1hSXRlbRKRAQoIR2V0U3RhdHMSQi5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JQZXJpb2RvUmVxdWVzdBpBLnNleHRhbnRlLnBsYXRhZm9ybWEudGVyY2Vyb3MucHJvbW90b3Jlcy52MS5Qcm9tb3RvclN0YXRzUmVzcG9uc2USkAEKCkdldENhcnRlcmESPS5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JJZFJlcXVlc3QaQy5zZXh0YW50ZS5wbGF0YWZvcm1hLnRlcmNlcm9zLnByb21vdG9yZXMudjEuUHJvbW90b3JDYXJ0ZXJhUmVzcG9uc2USmQEKDEdldEhpc3RvcmlhbBJCLnNleHRhbnRlLnBsYXRhZm9ybWEudGVyY2Vyb3MucHJvbW90b3Jlcy52MS5Qcm9tb3RvclBlcmlvZG9SZXF1ZXN0GkUuc2V4dGFudGUucGxhdGFmb3JtYS50ZXJjZXJvcy5wcm9tb3RvcmVzLnYxLlByb21vdG9ySGlzdG9yaWFsUmVzcG9uc2VCFqoCE0FwaS5HcnBjLlBsYXRhZm9ybWFiBnByb3RvMw");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.ListPromotoresRequest
 */
export type ListPromotoresRequest = Message<"sextante.plataforma.terceros.promotores.v1.ListPromotoresRequest"> & {
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.ListPromotoresRequest.
 * Use `create(ListPromotoresRequestSchema)` to create a new message.
 */
export const ListPromotoresRequestSchema: GenMessage<ListPromotoresRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 0);

/**
 * Promotores no eliminados, por nombre.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.ListPromotoresResponse
 */
export type ListPromotoresResponse = Message<"sextante.plataforma.terceros.promotores.v1.ListPromotoresResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.promotores.v1.PromotorPlataformaItem items = 1;
   */
  items: PromotorPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.ListPromotoresResponse.
 * Use `create(ListPromotoresResponseSchema)` to create a new message.
 */
export const ListPromotoresResponseSchema: GenMessage<ListPromotoresResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 1);

/**
 * Promotor comercial.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorPlataformaItem
 */
export type PromotorPlataformaItem = Message<"sextante.plataforma.terceros.promotores.v1.PromotorPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string telefono = 4;
   */
  telefono: string;

  /**
   * interno | externo | distribuidor
   *
   * @generated from field: string tipo = 5;
   */
  tipo: string;

  /**
   * @generated from field: bool is_activo = 6;
   */
  isActivo: boolean;

  /**
   * Ausente = promotor anterior a la vinculacion, sin acceso de login.
   *
   * @generated from field: optional string usuario_plataforma_id = 7;
   */
  usuarioPlataformaId?: string | undefined;

  /**
   * Solo en la respuesta de GuardarPromotor: la ficha se enlazo a un usuario de Plataforma que ya existia con ese
   * correo, en vez de crear otro (Nitrofert). En los listados siempre false.
   *
   * @generated from field: bool enlazado_a_usuario_existente = 8;
   */
  enlazadoAUsuarioExistente: boolean;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorPlataformaItem.
 * Use `create(PromotorPlataformaItemSchema)` to create a new message.
 */
export const PromotorPlataformaItemSchema: GenMessage<PromotorPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 2);

/**
 * Promotor a crear o editar.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.GuardarPromotorRequest
 */
export type GuardarPromotorRequest = Message<"sextante.plataforma.terceros.promotores.v1.GuardarPromotorRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string telefono = 4;
   */
  telefono: string;

  /**
   * interno, externo o distribuidor.
   *
   * @generated from field: optional string tipo = 5;
   */
  tipo?: string | undefined;

  /**
   * @generated from field: optional bool is_activo = 6;
   */
  isActivo?: boolean | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.GuardarPromotorRequest.
 * Use `create(GuardarPromotorRequestSchema)` to create a new message.
 */
export const GuardarPromotorRequestSchema: GenMessage<GuardarPromotorRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 3);

/**
 * Promotor del que se piden datos.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorIdRequest
 */
export type PromotorIdRequest = Message<"sextante.plataforma.terceros.promotores.v1.PromotorIdRequest"> & {
  /**
   * @generated from field: string promotor_id = 1;
   */
  promotorId: string;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorIdRequest.
 * Use `create(PromotorIdRequestSchema)` to create a new message.
 */
export const PromotorIdRequestSchema: GenMessage<PromotorIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 4);

/**
 * Promotor y periodo a consultar.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorPeriodoRequest
 */
export type PromotorPeriodoRequest = Message<"sextante.plataforma.terceros.promotores.v1.PromotorPeriodoRequest"> & {
  /**
   * @generated from field: string promotor_id = 1;
   */
  promotorId: string;

  /**
   * Unix ms, inclusivos.
   *
   * @generated from field: int64 desde = 2;
   */
  desde: bigint;

  /**
   * @generated from field: int64 hasta = 3;
   */
  hasta: bigint;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorPeriodoRequest.
 * Use `create(PromotorPeriodoRequestSchema)` to create a new message.
 */
export const PromotorPeriodoRequestSchema: GenMessage<PromotorPeriodoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 5);

/**
 * Indicadores del promotor en el periodo.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorStatsResponse
 */
export type PromotorStatsResponse = Message<"sextante.plataforma.terceros.promotores.v1.PromotorStatsResponse"> & {
  /**
   * Clientes no eliminados de su cartera.
   *
   * @generated from field: int32 clientes_activos = 1;
   */
  clientesActivos: number;

  /**
   * Clientes de su cartera creados en el periodo.
   *
   * @generated from field: int32 clientes_nuevos = 2;
   */
  clientesNuevos: number;

  /**
   * Oportunidades creadas en el periodo.
   *
   * @generated from field: int32 oportunidades = 3;
   */
  oportunidades: number;

  /**
   * Oportunidades ganadas en el periodo.
   *
   * @generated from field: int32 cierres = 4;
   */
  cierres: number;

  /**
   * Porcentaje de cierres sobre oportunidades.
   *
   * @generated from field: double tasa_conversion = 5;
   */
  tasaConversion: number;

  /**
   * Suma del valor de cierre de las oportunidades ganadas, en pesos.
   *
   * @generated from field: int64 ventas_totales = 6;
   */
  ventasTotales: bigint;

  /**
   * Ventas totales sobre cierres, en pesos.
   *
   * @generated from field: int64 ticket_promedio = 7;
   */
  ticketPromedio: bigint;

  /**
   * Serie de la grafica, con la granularidad de granularidad_grafica.
   *
   * @generated from field: repeated sextante.plataforma.terceros.promotores.v1.PromotorGraficaItem grafica_mensual = 8;
   */
  graficaMensual: PromotorGraficaItem[];

  /**
   * dia | semana | mes
   *
   * @generated from field: string granularidad_grafica = 9;
   */
  granularidadGrafica: string;

  /**
   * @generated from field: sextante.plataforma.terceros.promotores.v1.PromotorVsEquipo vs_equipo = 10;
   */
  vsEquipo?: PromotorVsEquipo | undefined;

  /**
   * @generated from field: repeated sextante.plataforma.terceros.promotores.v1.PromotorServicioItem distribucion_servicios = 11;
   */
  distribucionServicios: PromotorServicioItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorStatsResponse.
 * Use `create(PromotorStatsResponseSchema)` to create a new message.
 */
export const PromotorStatsResponseSchema: GenMessage<PromotorStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 6);

/**
 * Punto de la grafica del promotor.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorGraficaItem
 */
export type PromotorGraficaItem = Message<"sextante.plataforma.terceros.promotores.v1.PromotorGraficaItem"> & {
  /**
   * "yyyy-MM-dd" (dia/semana, inicio del bucket) o "yyyy-MM" (mes).
   *
   * @generated from field: string mes = 1;
   */
  mes: string;

  /**
   * @generated from field: int32 oportunidades = 2;
   */
  oportunidades: number;

  /**
   * @generated from field: int32 cierres = 3;
   */
  cierres: number;

  /**
   * @generated from field: int64 ventas = 4;
   */
  ventas: bigint;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorGraficaItem.
 * Use `create(PromotorGraficaItemSchema)` to create a new message.
 */
export const PromotorGraficaItemSchema: GenMessage<PromotorGraficaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 7);

/**
 * Promedios del equipo en el mismo periodo, para comparar.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorVsEquipo
 */
export type PromotorVsEquipo = Message<"sextante.plataforma.terceros.promotores.v1.PromotorVsEquipo"> & {
  /**
   * @generated from field: double tasa_conversion = 1;
   */
  tasaConversion: number;

  /**
   * @generated from field: double oportunidades = 2;
   */
  oportunidades: number;

  /**
   * @generated from field: int64 ticket_promedio = 3;
   */
  ticketPromedio: bigint;

  /**
   * @generated from field: double clientes_nuevos = 4;
   */
  clientesNuevos: number;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorVsEquipo.
 * Use `create(PromotorVsEquipoSchema)` to create a new message.
 */
export const PromotorVsEquipoSchema: GenMessage<PromotorVsEquipo> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 8);

/**
 * Cierres del periodo que incluyen un servicio.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorServicioItem
 */
export type PromotorServicioItem = Message<"sextante.plataforma.terceros.promotores.v1.PromotorServicioItem"> & {
  /**
   * @generated from field: string servicio = 1;
   */
  servicio: string;

  /**
   * @generated from field: int32 cantidad = 2;
   */
  cantidad: number;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorServicioItem.
 * Use `create(PromotorServicioItemSchema)` to create a new message.
 */
export const PromotorServicioItemSchema: GenMessage<PromotorServicioItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 9);

/**
 * Clientes de la cartera del promotor.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorCarteraResponse
 */
export type PromotorCarteraResponse = Message<"sextante.plataforma.terceros.promotores.v1.PromotorCarteraResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.promotores.v1.PromotorCarteraItem items = 1;
   */
  items: PromotorCarteraItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorCarteraResponse.
 * Use `create(PromotorCarteraResponseSchema)` to create a new message.
 */
export const PromotorCarteraResponseSchema: GenMessage<PromotorCarteraResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 10);

/**
 * Cliente de la cartera del promotor.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorCarteraItem
 */
export type PromotorCarteraItem = Message<"sextante.plataforma.terceros.promotores.v1.PromotorCarteraItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: int32 cant_fincas = 3;
   */
  cantFincas: number;

  /**
   * @generated from field: double hectareas_totales = 4;
   */
  hectareasTotales: number;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_vencimiento_plataforma = 5;
   */
  fechaVencimientoPlataforma?: bigint | undefined;

  /**
   * true si la licencia esta vigente.
   *
   * @generated from field: bool plan_activo = 6;
   */
  planActivo: boolean;

  /**
   * dataag | rastro | bascula | vista | protec (de su ultima oportunidad ganada).
   *
   * @generated from field: repeated string servicios_activos = 7;
   */
  serviciosActivos: string[];

  /**
   * Unix ms
   *
   * @generated from field: optional int64 ultima_oportunidad_fecha = 8;
   */
  ultimaOportunidadFecha?: bigint | undefined;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorCarteraItem.
 * Use `create(PromotorCarteraItemSchema)` to create a new message.
 */
export const PromotorCarteraItemSchema: GenMessage<PromotorCarteraItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 11);

/**
 * Oportunidades del promotor en el periodo.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorHistorialResponse
 */
export type PromotorHistorialResponse = Message<"sextante.plataforma.terceros.promotores.v1.PromotorHistorialResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.terceros.promotores.v1.PromotorHistorialItem items = 1;
   */
  items: PromotorHistorialItem[];
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorHistorialResponse.
 * Use `create(PromotorHistorialResponseSchema)` to create a new message.
 */
export const PromotorHistorialResponseSchema: GenMessage<PromotorHistorialResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 12);

/**
 * Oportunidad del historial del promotor.
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.PromotorHistorialItem
 */
export type PromotorHistorialItem = Message<"sextante.plataforma.terceros.promotores.v1.PromotorHistorialItem"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * @generated from field: string cliente_nombre = 2;
   */
  clienteNombre: string;

  /**
   * Etapa del pipeline: new, contacted, demo, proposal, closed_won o closed_lost.
   *
   * @generated from field: string stage = 3;
   */
  stage: string;

  /**
   * Origen de la oportunidad: web, whatsapp, app, campo o manual.
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * Ausente = la oportunidad no tiene productos cargados.
   *
   * @generated from field: optional sextante.plataforma.terceros.promotores.v1.ProductosHistorialItem productos = 5;
   */
  productos?: ProductosHistorialItem | undefined;

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.PromotorHistorialItem.
 * Use `create(PromotorHistorialItemSchema)` to create a new message.
 */
export const PromotorHistorialItemSchema: GenMessage<PromotorHistorialItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 13);

/**
 * Solo lo que pinta el historial (badges por producto).
 *
 * @generated from message sextante.plataforma.terceros.promotores.v1.ProductosHistorialItem
 */
export type ProductosHistorialItem = Message<"sextante.plataforma.terceros.promotores.v1.ProductosHistorialItem"> & {
  /**
   * @generated from field: bool dataag = 1;
   */
  dataag: boolean;

  /**
   * Unidades de GPS RASTRO.
   *
   * @generated from field: int32 rastro = 2;
   */
  rastro: number;

  /**
   * Unidades de bascula.
   *
   * @generated from field: int32 bascula = 3;
   */
  bascula: number;

  /**
   * @generated from field: bool vista = 4;
   */
  vista: boolean;

  /**
   * @generated from field: bool protec_activo = 5;
   */
  protecActivo: boolean;
};

/**
 * Describes the message sextante.plataforma.terceros.promotores.v1.ProductosHistorialItem.
 * Use `create(ProductosHistorialItemSchema)` to create a new message.
 */
export const ProductosHistorialItemSchema: GenMessage<ProductosHistorialItem> = /*@__PURE__*/
  messageDesc(file_plataforma_terceros_promotores, 14);

/**
 * Promotores de la app Plataforma (menu Promotores; el listado lo usan tambien el form de cliente y
 * Pipeline). Migracion a gRPC-Web con logica propia (ver CLAUDE.md). Solo los campos que usa la web.
 * Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService
 */
export const PromotoresPlataformaService: GenService<{
  /**
   * Promotores no eliminados, por nombre.
   *
   * @generated from rpc sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService.ListPromotores
   */
  listPromotores: {
    methodKind: "unary";
    input: typeof ListPromotoresRequestSchema;
    output: typeof ListPromotoresResponseSchema;
  },
  /**
   * Alta (crea tambien su usuario de Plataforma con rol comercial y le manda el correo de bienvenida) o
   * edicion (si cambia el email, se actualiza el del usuario). Email unico entre promotores.
   *
   * @generated from rpc sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService.GuardarPromotor
   */
  guardarPromotor: {
    methodKind: "unary";
    input: typeof GuardarPromotorRequestSchema;
    output: typeof PromotorPlataformaItemSchema;
  },
  /**
   * KPIs del periodo, grafica por dia/semana/mes segun el ancho del rango, comparacion con el equipo y
   * distribucion por servicio. Oportunidades por ComercialId; clientes por Cliente.PromotorId.
   *
   * @generated from rpc sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof PromotorPeriodoRequestSchema;
    output: typeof PromotorStatsResponseSchema;
  },
  /**
   * Cartera formal (clientes con PromotorId = este promotor), independiente del periodo.
   *
   * @generated from rpc sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService.GetCartera
   */
  getCartera: {
    methodKind: "unary";
    input: typeof PromotorIdRequestSchema;
    output: typeof PromotorCarteraResponseSchema;
  },
  /**
   * Oportunidades del promotor creadas en el periodo, de la mas reciente a la mas antigua.
   *
   * @generated from rpc sextante.plataforma.terceros.promotores.v1.PromotoresPlataformaService.GetHistorial
   */
  getHistorial: {
    methodKind: "unary";
    input: typeof PromotorPeriodoRequestSchema;
    output: typeof PromotorHistorialResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_terceros_promotores, 0);

